import * as React from "react";
import type { SVGProps } from "react";
const SvgNotify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#0535E4"
      fillRule="evenodd"
      d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm4.234 3H8.62v4.927H7.234zm1.614 7.076a.924.924 0 1 1-1.848 0 .924.924 0 0 1 1.848 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotify;
